/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { assistantMemoriesDelete } from "../funcs/assistantMemoriesDelete.js";
import { assistantMemoriesGet } from "../funcs/assistantMemoriesGet.js";
import { assistantMemoriesList } from "../funcs/assistantMemoriesList.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { AssistantMemory } from "../models/components/assistantmemory.js";
import {
  DeleteAssistantMemoryRequest,
  DeleteAssistantMemorySecurity,
} from "../models/operations/deleteassistantmemory.js";
import {
  GetAssistantMemoryRequest,
  GetAssistantMemorySecurity,
} from "../models/operations/getassistantmemory.js";
import {
  ListAssistantMemoriesRequest,
  ListAssistantMemoriesResponse,
  ListAssistantMemoriesSecurity,
} from "../models/operations/listassistantmemories.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class AssistantMemories extends ClientSDK {
  /**
   * deleteAssistantMemory assistantMemories
   *
   * @remarks
   * Delete an assistant memory by ID.
   */
  async delete(
    request: DeleteAssistantMemoryRequest,
    security?: DeleteAssistantMemorySecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(assistantMemoriesDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getAssistantMemory assistantMemories
   *
   * @remarks
   * Get an assistant memory by ID.
   */
  async get(
    request: GetAssistantMemoryRequest,
    security?: GetAssistantMemorySecurity | undefined,
    options?: RequestOptions,
  ): Promise<AssistantMemory> {
    return unwrapAsync(assistantMemoriesGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listAssistantMemories assistantMemories
   *
   * @remarks
   * List assistant memories for an assistant.
   */
  async list(
    request: ListAssistantMemoriesRequest,
    security?: ListAssistantMemoriesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListAssistantMemoriesResponse, { cursor: string }>> {
    return unwrapResultIterator(assistantMemoriesList(
      this,
      request,
      security,
      options,
    ));
  }
}
